export function getFieldError({ form, field }) {
    if (String(field.name).includes(".")) {
        const levels = String(field.name).split(".");
        return levels.reduce((value, level) => value && value[level], form.errors || {});
    }
    return form.touched[field.name] && form.errors[field.name];
}
